/**
 * Photosensitivity notice — first run only.
 *
 * Shown BEFORE anything animates. A warning that appears after the title screen
 * has already flickered red is not a warning; the hazard has to be gated, not
 * annotated. This screen is deliberately static: no CRT pass, no flicker, no
 * red, no motion of any kind.
 *
 * Declining leaves `effects` at 'reduced', which is also the default — so the
 * safe path requires no action and the risky one requires an explicit tap.
 */

export function Warning({ onChoose }: { onChoose: (enableFullEffects: boolean) => void }) {
  return (
    <div className="warn" role="dialog" aria-modal="true" aria-labelledby="warn-h">
      <div className="warn-card">
        <h1 id="warn-h">Предупреждение</h1>
        <p>
          Игра использует визуальные эффекты в стиле аналогового хоррора: помехи,
          мерцание и резкие вспышки. У людей с фоточувствительной эпилепсией они
          могут вызвать приступ.
        </p>
        <p>
          Эффекты можно включить сейчас или позже в настройках. По умолчанию
          мерцание и вспышки выключены.
        </p>

        <div className="warn-actions">
          <button className="warn-primary" onClick={() => onChoose(false)} autoFocus>
            Продолжить без вспышек
          </button>
          <button className="warn-secondary" onClick={() => onChoose(true)}>
            Включить все эффекты
          </button>
        </div>

        <p className="warn-note">Изменить можно в любой момент: Настройки → Эффекты.</p>
      </div>
    </div>
  );
}
